import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import './assets/stylus/main.styl'
import VueAnalytics from 'vue-analytics'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'
import './sass/variables.scss'
import * as VueGoogleMaps from 'vue2-google-maps'

if (process.env.NODE_ENV !== 'development') {
  Vue.use(VueAnalytics, {
    id: 'UA-149261089-1',
    router
  })
}

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC1-NtffE5dsko8YPnmeqDngENGOvL8oq8',
    libraries: 'places'
  }
})

Vue.use(Croppa)

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

